module.exports = __webpack_public_path__ + "static/media/eenheden.d99758db.jpg";